<template>
<v-layout align-center justify-center row fill-height :class="{'mb-7': cargado }">
  <v-row no-gutters align="center" justify="center" class="mb-0">
     <v-col cols="2" v-if="!nuevo && !cargado">
        <v-btn
          small
          color="blue-grey"
          class="mt-n6 mx-2 white--text " 
          @click="nuevoForm">
          Nuevo
          <v-icon right dark small>
            fas fa-file-medical
          </v-icon>
        </v-btn>
    </v-col>
    <v-col cols="3" justify="start" v-if="!nuevo && cargado">
      <v-btn
        small
        color="error"
        class="mt-n6 mx-2 white--text " 
        @click="CancelForm">
        Cancelar
        <v-icon right dark small>
          fas fa-times
        </v-icon>
      </v-btn>
    </v-col>  
    <v-col cols="5" v-if="!nuevo && !cargado">
      <v-select
        v-model="formulario"
        :items="aFormularios"
        item-text="NombreFormulario"
        item-value="idFD_Formulario"
        class="mt-3 mx-2"
        clearable
        solo
        label="Seleccione un Fomulario"
        @change="changeFormulario"
      ></v-select>
    </v-col>
    <v-col cols="6"  v-if="nuevo">
      <v-text-field
        v-model="newFormName"
        background-color="white"
        class="mt-3 mx-2"
        label="Nuevo Formulario"
        placeholder="Escribe el nombre del formulario"
        outlined
      ></v-text-field>
    </v-col>
     <v-col cols="2" v-if="!nuevo && !cargado">
        <v-btn
          small
          :disabled="formulario == ''"
          color="info"
          class="mt-n6 mx-2 white--text"
          @click="Cargar">
          Cargar
          <v-icon right dark small>
            fas fa-file
          </v-icon>
        </v-btn>
    </v-col>
    <v-col cols="3" justify="end" v-if="nuevo">
      <v-btn
        small
        color="error"
        class="mt-n6 mx-2 white--text " 
        @click="cancelar">
        Cancelar
        <v-icon right dark small>
          fas fa-times
        </v-icon>
      </v-btn>
    </v-col>  
     <v-col cols="3" justify="end">
        <v-btn
          small
          color="success"
          class="mt-n6 mx-3 white--text " 
          @click="guardar">
          Guardar
          <v-icon right dark small>
            fas fa-file-upload
          </v-icon>
        </v-btn>
    </v-col>
  </v-row> 
</v-layout>   
</template>

<script>
import axiosServices from '@/services/axiosServices.js'

export default {
  name:"FormControl",
  props: {
    value : {
      type:String
    }
  },
  data() {
    return {
      nuevo: false,
      aFormularios: [],
      formulario: '',
      cargado:false,
      newFormName: ''
    }
  },
  mounted () {
    this.getFormularios()
  },
  methods: {
    async getFormularios() {
      const axiosFromularios = await axiosServices.getConfiguration('buildDinamicos/formularios', true )
      this.aFormularios = axiosFromularios.aData

    },
    changeFormulario(){
      const auxFormulario =  this.aFormularios.find( form => form.idFD_Formulario == this.formulario)
      this.$emit('input', auxFormulario == undefined ? '' : auxFormulario.NombreFormulario)
    },
    async guardar(){

      if(this.nuevo){
        const oBody = { 
          'Formulario' : this.newFormName
        }
        const axiosPostFormulario =  await axiosServices.postConfiguration('buildDinamicos/formularios', oBody)

        this.getFormularios()
        this.formulario = axiosPostFormulario.aData.idFD_Formulario

        this.$emit('input',axiosPostFormulario.aData.NombreFormulario)
        
        this.nuevo=false
      }


      if(this.cargado){
        const oBody = this.$store.state.board.columns[1]

        await axiosServices.postConfiguration('buildDinamicos/save', oBody )
      }

      this.nuevo=false
      this.cargado = false
      this.$store.dispatch('cleanCampos');

    },
    nuevoForm() {
      this.$store.dispatch('cleanCampos');
      this.nuevo = true
      this.formulario = ''
    },
    async Cargar(){
      this.cargado = true
      
      // cargo en el registro 1 del board las informacion del formulario que cargue
      this.$store.dispatch('salvarFormulario', this.formulario)

      // obtengo la informacion 
      this.$store.dispatch('cleanCampos');
      const axiosFromularios = await axiosServices.getConfiguration('buildDinamicos/load', true, `idFormulario=${this.formulario}` )
      this.$store.state.board.columns[1].campos = axiosFromularios.aData
      this.formulario = ''

    },
    cancelar(){
      this.nuevo=false
      this.$store.dispatch('cleanCampos');
    },
    CancelForm(){
      this.cargado = false
      this.$store.dispatch('cleanCampos');

    }
  },
  watch: {
    newFormName(newValue){
      this.newFormName = newValue.toUpperCase();
    }
  },
  
}
</script>

<style lang="scss" scoped>

</style>